import React from 'react';
import { useStoreContext } from '../../contexts/StoreContext';
import PublicLayout from './PublicLayout';
import StorefrontLayout from './StorefrontLayout';
import Skeleton from '../common/Skeleton';
import Container from './Container';

// Em rotas públicas (Reviter LP, storefront, auth, carrinho, checkout) o
// layout depende de quem o host está servindo:
// - sem tenant resolvido → PublicLayout (Header/Footer institucionais).
// - com tenant → StorefrontLayout (header com busca + categorias da loja).
//
// Enquanto StoreProvider está resolvendo (loading), evitamos render pra não
// piscar layout errado por uma fração de segundo.
const PublicLayoutSwitch = () => {
  const { isStoreSite, loading } = useStoreContext();

  if (loading) {
    return (
      <div className="min-h-screen bg-app-bg">
        <Container>
          <div className="py-10">
            <Skeleton variant="block" height={120} />
          </div>
        </Container>
      </div>
    );
  }

  return isStoreSite ? <StorefrontLayout /> : <PublicLayout />;
};

export default PublicLayoutSwitch;
